import script from "./IngredientVisualization.vue?vue&type=script&setup=true&lang=js"
export * from "./IngredientVisualization.vue?vue&type=script&setup=true&lang=js"

import "./IngredientVisualization.vue?vue&type=style&index=0&id=f38eedec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f38eedec"]])

export default __exports__